import { UnitDomainDTO } from '@api/gateway/PlatformTrade'
import { TeachUnit } from '@api/model/basic-data/TeachUnit'

class TeachUnitDetails extends TeachUnit {
  defaultUnitDomain: UnitDomainDTO
}

export default TeachUnitDetails
